module.exports = __webpack_public_path__ + "static/img/6.f28c6f7a.png";